import type { ReactNode } from "react";

type PortfolioPageSectionBadgeProps = {
  children: ReactNode;
  type: "dark" | "light";
};

export function PortfolioPageSectionBadge({
  children,
  type,
}: PortfolioPageSectionBadgeProps) {
  return <span className="app-section-eyebrow">{children}</span>;
}
